export enum Pagination {
    PAGE_SIZE = 20,
    DEFAULT_PAGE = 1,
    DEFAULT_OFFSET = 0
}